export class BarcodeDimensions {
  constructor(
    public width: number,
    public height: number,
    public sheetMarginTop: number,
    public sheetMarginLeft: number,
    public showAuthor: boolean,
    public showClass: boolean
  ) {}

  public static clone(bd: BarcodeDimensions): BarcodeDimensions {
    return new BarcodeDimensions(
      bd.width,
      bd.height,
      bd.sheetMarginTop,
      bd.sheetMarginLeft,
      bd.showAuthor,
      bd.showClass
    );
  }

  // removed backend db structure
}













